import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from 'core/components';
import { StatusCode } from 'core/constants';
import { homePath } from 'home/routes/routePaths';
import { Level } from 'theme/enums';

import { ContentWrapper, SubTitle, Title, Wrapper } from './errorStyle';

interface IProps {
  statusCode?: StatusCode;
}

const getMessage = (statusCode: StatusCode) => {
  switch (statusCode) {
    case StatusCode.ACCESS_DENIED:
      return 'messageAccessDenied';
    case StatusCode.NOT_FOUND:
      return 'messageNotFound';
    case StatusCode.SERVER_ERROR:
    default:
      return 'serverError';
  }
};

const Error = ({ statusCode = StatusCode.NOT_FOUND }: IProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <HelmetProvider>
      <Helmet>
        <title>{t('labelNotFound')}</title>
      </Helmet>

      <Wrapper>
        <ContentWrapper>
          <Title level={Level.H1}>{statusCode}</Title>
          <SubTitle level={Level.H2}>{t(getMessage(statusCode))}</SubTitle>

          <Button
            variant="soft"
            onClick={() => navigate(homePath())}
            text={t('buttonLabelGoToHomepage')}
          />
        </ContentWrapper>
      </Wrapper>
    </HelmetProvider>
  );
};

export default Error;
